import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ac4238b8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "projectDetailBox"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "详情内容", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1));
const _hoisted_4 = ["innerHTML"];
import { ref } from "vue";
// const ProjectContent = ref('<p>这是一套最新自助图文打印系统和证件照云打印小程序源码PHP 后端，为用户用户自助打印的服务，包括但不限于文档、图片、表格等多种格式的文件。此外，它们还提供了诸如美颜、换装、文档打印等功能，以及后台管理系统，方便管理员对打印机进行管理。</p>\n' +
//     '<p>安装配置：</p>\n' +
//     '<p>&nbsp;</p>\n' +
//     '<p>后端安装说明：</p>\n' +
//     '<p>测试环境：Nginx+PHP7.4+MySQL5.6</p>\n' +
//     '<p>PHP安装扩展：sg11</p>\n' +
//     '<p>网站运行目录设置为：/public</p>\n' +
//     '<p>网站伪静态规则设置为：thinkphp</p>\n' +
//     '<p>网站需要开启https证书</p>\n' +
//     '<p>数据库修改文件路径：/config/database.php</p>\n' +
//     '<p>后台账号密码为：admin/123456</p>\n' +
//     '<p>&nbsp;</p>\n' +
//     '<p>前端安装说明：</p>\n' +
//     '<p>使用微信开发者工具导入项目文件夹</p>\n' +
//     '<p>小程序源码中的app.js文件打开修改成自己的域名</p>\n' +
//     '<p>微信小程序平台把自己的域名加入到合法域名中</p>\n' +
//     '<p><img src="https://www.icbot.net/upload/portal/20240709/398488ed9cc5d6a20edb24bb9ba0c59f.png" referrerpolicy="no-referrer" alt="img"></p>\n')
export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectDetailDetail',
  props: {
    projectDetail: {}
  },
  setup(__props) {
    const ProjectContent = ref('');
    const props = __props;
    return (_ctx, _cache) => {
      const _directive_highlight = _resolveDirective("highlight");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _withDirectives(_createElementVNode("div", {
        class: "markdown-body",
        innerHTML: _ctx.projectDetail.overview
      }, null, 8, _hoisted_4), [[_directive_highlight]])]);
    };
  }
});